<template>
    <div class="p-0">
        <div class="list-orders prolong-list container p-0">
            <div v-if="! isMobile" class="tabs-block"></div>
            <div v-else></div>
            <div v-if="! isMobile" class="tabs-block">
                <ul class="status-tabs">
                    <li @click="activateTab(status)" v-for="(status, index) in getProlongClientStatuses()" class="tab">
                        <a v-bind:class="{ active: listQuery.prolongClientStatus === status.id}"
                           href="javascript:void(0);"> {{ status.name || 'Всі' }}</a>
                    </li>
                    <li @click="activateTab(getProlongLostStatus())" class="tab">
                        <a v-bind:class="{ active: listQuery.statusLost }"
                           href="javascript:void(0);"> {{ `Втрачені` || 'Всі' }}</a>
                    </li>
                </ul>
            </div>
            <div v-else>
                <div class="form-group">
                    <el-select
                               v-model="listQuery.prolongClientStatus"
                               @change="activateTab"
                               class="form-control-el select-prolong-tab"
                               popper-class="select-prolong-tab-list"
                               placeholder="Виберіть статус">
                        <el-option v-for="item in prolongStatuses"
                                   :key="item.id"
                                   :label="item.name || 'Всі'"
                                   :value="item.id">
                        </el-option>
                    </el-select>
                </div>
            </div>
            <div class="container empty-notification" v-if="! isLoadData && (orders && orders.length < 1)">
                <img src="~@/assets/images/empty_img.svg" alt="">
                <div class="empty-notification__text">
                    <p v-if="isProlongation()">Тут будуть з`являтися страховi полiси, дата закiнчення яких через 30 днiв, або ранiше.
                        Оформіть страховку або змініть параметри  <a href="javascript:void(0);" @click="filterStatusWrap()">фільтра</a>  замовлень.</p>
                    <p v-else-if="isDraftTab()">Тут будуть з'являтися страхові поліси зі статусом чернетка. Створіть чернетку або змініть параметри <a href="javascript:void(0);" @click="filterStatusWrap()">фільтра</a> замовлень.</p>
                    <p v-else-if="isDeclaredTab()">Тут будуть з'являтися страхові поліси зі статусом заявлений. Заявіть чернетку або змініть параметри <a href="javascript:void(0);" @click="filterStatusWrap()">фільтра</a> замовлень.</p>
                    <p v-else-if="isCanceledTab()">Тут будуть з'являтися страхові поліси зі статусом припинений. Змінити параметри <a href="javascript:void(0);" @click="filterStatusWrap()">фільтра</a> замовлень.</p>
                    <p v-else>Ваша історія замовлень поки порожня. Оформіть страховку або змініть параметри
                        <a href="javascript:void(0);" @click="filterStatusWrap()">фільтра</a> замовлень.</p>
                </div>
                <a data-toggle="modal" data-target="#modalSearch" class="header__create">Cтворити
                    страховку</a>
            </div>
            <div class="container-wrapp" v-else-if="! isMobile">
                <div class="header-block">
                    <ul class="columns-block">
                        <li class="column">Тип статусу</li>
                        <li class="column">Номер поліса</li>
                        <li class="column">Дата</li>
                        <li class="column">Страхувальник</li>
                        <li class="column">Вартість, грн</li>
                        <li class="column">Заробіток, грн</li>
                    </ul>
                </div>
                <div v-if="isLoadData">
                    <row-block-skeleton v-for="index in 4" :key="index"></row-block-skeleton>
                </div>
                <div v-else v-for="order in orders" class="row-block">
                    <ul class="columns-block">
                        <li class="column">
                            <div class="column-block">
                                <span class="order-type">{{ showTypeInsurance(order) }}</span>
                                <el-select v-model="order.prolongClientStatus"
                                           :class="`form-control-el select-prolong-status ${ getSelectClass(order.prolongClientStatus) }`"
                                           @change="changeProlongStatus($event, order)"
                                           placeholder="">
                                    <el-option v-for="item in getProlongStatuses()"
                                               :key="item.id"
                                               :label="item.name"
                                               :value="item.id">
                                    </el-option>
                                </el-select>
                                <span v-if="isProlongationOrder(order)" style="margin-top: 10px">
                                  <svg style="margin-top: -7px;" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <line x1="10" y1="4" x2="10" y2="12" stroke="#EF4E4E" stroke-width="2"/>
                                    <line x1="10" y1="13.5" x2="10" y2="16" stroke="#EF4E4E" stroke-width="2"/>
                                    <circle cx="10" cy="10" r="9" stroke="#EF4E4E" stroke-width="2"/>
                                  </svg>
                                    <span>
                                        Cкоро закінчується
                                    </span>
                                </span>
                                <div class="bottom-part order-status">
                                    <div class="bottom-block right-border">
                                        <span>Статус:</span>
                                        <div :class="['status', getStatusClass(order)]"><span>{{
                                                showStatusName(order)
                                            }}</span></div>
                                    </div>
                                </div>
                            </div>
                        </li>
                        <li class="column">
                            <div class="column-block">
                                <a  class="order-number" target="_blank"  :href="showMtsbuLink(order)" v-if="showMtsbuLink(order)">
                                    {{ showMtsbuCode(order) }}<br />{{ showMtsbuCodeAdditionalInfo(order) }}
                                </a>
                                <span v-else-if="showMtsbuCode(order)" class="order-number">
                                    {{ showMtsbuCode(order) }}
                                </span>
                                <span class="order-number" v-else>&mdash;</span>
                                <div class="bottom-part order-user">
                                    <div class="bottom-block right-border">
                                        <div class="option-block">
                                            <span>Точка продажу:</span>
                                            <div class="user-name"
                                                 data-toggle="tooltip" data-placement="bottom"
                                                 :title="showNameInsured(order)">
                                                {{ showNameInsured(order) }}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </li>
                        <li class="column">
                            <div class="column-block">
                                <div>
                                    <div class="date-block">
                                        <div class="text">Створений:</div>
                                        <span v-if="order.createdAt" class="date">{{ order.createdAt }}</span>
                                        <span v-else class="date">&mdash;</span>
                                    </div>
                                    <div class="date-block">
                                        <div class="text">Початок:</div>
                                        <span v-if="showStartedAtContract(order)"
                                              class="date">{{ showStartedAtContract(order) }}</span>
                                        <span v-else class="date">&mdash;</span>
                                    </div>
                                    <div class="date-block">
                                        <div class="text">Закінчення:</div>
                                        <span v-if="showFinishedAtContract(order)"
                                              class="date">{{ showFinishedAtContract(order) }}</span>
                                        <span v-else class="date">&mdash;</span>
                                    </div>
                                </div>
                                <div class="bottom-part order-company">
                                    <div class="bottom-block right-border">
                                        <div class="option-block">
                                            <span class="option">СК:</span>
                                            <div class="result"
                                                 data-toggle="tooltip" data-placement="bottom"
                                                 :title="order.companyInfo.name">
                                                <ellipsis
                                                    :data="order.companyInfo.name">
                                                </ellipsis>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </li>
                        <li class="column">
                            <div class="column-block">
                                <div class="order-insured">
                                    <a class="dark-link" :href="'/clients/'+order.client_id">
                                        <div v-if="showNameInsurantSurname(order)">
                                            <span>{{ showNameInsurantSurname(order) }}</span>
                                        </div>
                                        <div style="">
                                            <span>{{ showNameInsurantName(order) }}</span>
                                        </div>
                                        <div style="">
                                            <span>{{ showNameInsurantPatronymic(order) }}</span>
                                        </div>
                                    </a>
                                </div>
                                <div class="bottom-part order-company">
                                    <div class="bottom-block right-border">
                                        <span class="result">{{ order.insuranceObject.number }}</span>
                                    </div>
                                </div>
                            </div>
                        </li>
                        <li class="column">
                            <div class="column-block">
                                <div>
                                    <div class="price-block">
                                        <div class="text">Первісна:</div>
                                        <span class="date">{{ showPrice(order) }}</span>
                                    </div>
                                    <div v-if="showDiscount(order) || showMonths(order)" class="price-block">
                                        <div class="text">Зі знижкою:</div>
                                        <span class="date">{{ showAllPrice(order) }} <i class="icon question" data-html="true" data-placement="bottom" data-select="true" data-toggle="tooltip" title="Первісна вартість може бути знижена за рахунок знижки посередника та за рахунок виключення місяців, з періоду дії полісу."></i></span>
                                    </div>
                                </div>
                                <div class="bottom-part" >
                                    <div class="bottom-part" >
                                        <div>
                                          <span v-if="showOption(order,'prolongation_contract') && !isFisReferal()">
                                            <svg style="margin-bottom: 4px" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                              <path d="M11.6 3.2002H4.4C3.07452 3.2002 2 4.27471 2 5.6002V11.6002C2 12.9257 3.07452 14.0002 4.4 14.0002H11.6C12.9255 14.0002 14 12.9257 14 11.6002V5.6002C14 4.27471 12.9255 3.2002 11.6 3.2002Z" stroke="#999DA6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                              <path d="M5.59961 2V4.4" stroke="#999DA6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                              <path d="M10.4004 2V4.4" stroke="#999DA6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                              <path d="M2 6.80029H14" stroke="#999DA6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                            </svg>
                                            <div v-if="order.typeId === orderTypes['miniKasko']" class="d-inline-flex buttom-block">
                                              <div @click="prolongNew(order)" style="color:#24282C; cursor: pointer" class="option">Продовжити</div>
                                            </div>
                                            <div v-else class="d-inline-flex">
                                              <prolongation-choice
                                                  @prolong-new="prolongNew(order)"
                                                  @prolong-current="prolong(order)"
                                                  :isLoadingNew="loadProcessNew"
                                                  :isLoadingCurrent="loadProcessCurrent"
                                              >
                                              </prolongation-choice>
                                            </div>
                                          </span>
                                            <div class="d-inline-flex">
                                                <client-info :client="order.insurant"  ref="clientInfo"></client-info>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </li>
                        <li class="column">
                            <div class="column-block">
                                <div>
                                    <div class="price-block" v-if="order.allEarnings">
                                        <div class="text">Загальний:</div>
                                        <span class="price">{{ order.allEarnings }}</span>
                                    </div>
                                    <div class="price-block">
                                        <div class="text">Ваш:</div>
                                        <span v-if="order.myEarnings" class="price">{{ order.myEarnings }}</span>
                                        <span v-else class="price">&mdash;</span>
                                    </div>
                                    <div class="price-block" v-if="order.isPartnerOrder">
                                        <div class="text">Агента:</div>
                                        <span v-if="order.partnerEarnings" class="price">{{
                                                order.partnerEarnings
                                            }}</span>
                                        <span v-else class="date">&mdash;</span>
                                    </div>
                                </div>
                                <div class="bottom-part">
                                    <div v-if="loadMoreOptions[order.id + order.typeId] === true"
                                         class="option-loader spinner-border"
                                         style="height: 14px; width: 14px; margin-bottom: 4px;"
                                         role="status">
                                    </div>
                                    <more-options v-else :status-order="showStatusId(order)"
                                                  :order-type="order.typeId"
                                                  @download-draft="showDraft(order)"
                                                  @download-contract="showContract(order)"
                                                  @show-order="goToOrderInfo(order)"
                                                  @proceed-order="declare(order)"
                                                  @confirm-order="declare(order,false,false,2)"
                                                  @open-mtsbu-link="openMtsbuLink(order)"
                                                  @get-payment-invoice="getPaymentInvoice(order)"
                                                  :is-exist-mtsbu-link="showMtsbuLink(order)"
                                                  @copy-order="copy(order)">
                                    </more-options>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <div v-else>
                <div class="mobile-columns-block">
                    <div v-if="isLoadData">
                        <row-mobile-block-skeleton v-for="index in 4" :key="index"></row-mobile-block-skeleton>
                    </div>
                    <div v-else>
                        <div v-for="order in orders" class="row order-data">
                            <div v-if="isProlongationOrder(order)" class="col-12 mb-3">
                                <div style="margin-top: 10px">
                                        <span>
                                          <svg style="margin-top: -7px;" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <line x1="10" y1="4" x2="10" y2="12" stroke="#EF4E4E" stroke-width="2"/>
                                            <line x1="10" y1="13.5" x2="10" y2="16" stroke="#EF4E4E" stroke-width="2"/>
                                            <circle cx="10" cy="10" r="9" stroke="#EF4E4E" stroke-width="2"/>
                                          </svg>
                                        </span>
                                    <span>
                                       Скоро закінчується
                                    </span>
                                </div>
                            </div>
                            <div class="col-7 half-block">
                                <div class="info-block">
                                    <div class="option">Тип поліса</div>
                                    <div class="value">{{ showTypeInsurance(order) }}</div>
                                    <el-select v-model="order.prolongClientStatus"
                                               :class="`form-control-el select-prolong-status ${ getSelectClass(order.prolongClientStatus) }`"
                                               @change="changeProlongStatus($event, order)"
                                               placeholder="">
                                        <el-option v-for="item in getProlongStatuses()"
                                                   :key="item.id"
                                                   :label="item.name"
                                                   :value="item.id">
                                        </el-option>
                                    </el-select>
                                </div>
                                <div class="info-block">
                                    <div class="option">Дата</div>
                                    <div class="sub-options">
                                        <div>
                                            <span class="sub-option">Створений:</span>
                                            <span v-if="order.createdAt" class="value">{{ order.createdAt }}</span>
                                            <span v-else class="value">&mdash;</span>
                                        </div>
                                        <div>
                                            <span class="sub-option">Початок:</span>
                                            <span v-if="showStartedAtContract(order)"
                                                  class="value">{{ showStartedAtContract(order) }}</span>
                                            <span v-else class="value">&mdash;</span>
                                        </div>
                                        <div>
                                            <span class="sub-option">Закінчення:</span>
                                            <span v-if="showFinishedAtContract(order)"
                                                  class="value">{{ showFinishedAtContract(order) }}</span>
                                            <span v-else class="value">&mdash;</span>
                                        </div>
                                    </div>
                                </div>
                                <div class="info-block">
                                    <div class="option">Вартість, грн</div>
                                    <div class="sub-options">
                                        <div>
                                            <span class="sub-option">Первісна:</span>
                                            <span class="value">{{ showPrice(order) }}</span>
                                        </div>
                                        <div v-if="showDiscount(order)">
                                            <span class="sub-option">Зі знижкою:</span>
                                            <span class="value">{{ showDiscount(order) }}</span>
                                        </div>
                                        <div v-if="showDgoPrice(order)">
                                            <span class="sub-option">ДЦВ:</span>
                                            <span class="value">{{ showDgoPrice(order) }}</span>
                                        </div>

                                        <div class="mt-4 mb-1">
                                            <span class="sub-option">Статус:</span>
                                            <div :class="['value status', getStatusClass(order)]">
                                                <span>{{ showStatusName(order) }}</span>
                                            </div>
                                        </div>
                                        <div class="d-flex">
                                            <span class="sub-option">Точка продажу:</span>
                                            <span data-toggle="tooltip" data-placement="bottom"
                                                  :title="showNameInsured(order)"
                                                  class="value">
                                            {{ showNameInsured(order) }}
                                        </span>
                                        </div>
                                        <div class="d-flex">
                                            <span class="sub-option">СК:</span>
                                            <span class="value">
                                            <ellipsis :data="order.companyInfo.name"></ellipsis>
                                        </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-5 half-block">
                                <div class="info-block">
                                    <div class="option">Номер поліса</div>
                                    <div class="value">
                                        <a :href="showMtsbuLink(order)" v-if="showMtsbuLink(order)">
                                            {{ showMtsbuCode(order) }}
                                        </a>
                                        <span v-else-if="showMtsbuCode(order)" class="order-number">
                                            {{ showMtsbuLink(order) }}
                                        </span>
                                        <span class="order-number" v-else>&mdash;</span>
                                    </div>
                                </div>
                                <div class="info-block">
                                    <div class="option">Страхувальник</div>
                                    <a class="dark-link" :href="'/clients/'+order.client_id">
                                        <div class="value">
                                            {{ showNameInsurantSurname(order) }}
                                        </div>
                                        <div class="value">
                                            {{ showNameInsurantName(order) }}
                                        </div>
                                        <div class="value">
                                            {{ showNameInsurantPatronymic(order) }}
                                        </div>
                                    </a>
                                </div>
                                <div class="info-block">
                                    <div class="option">Заробіток, грн</div>
                                    <div class="sub-options">
                                        <div v-if="order.isPartnerOrder">
                                            <span class="sub-option">Загальний:</span>
                                            <span v-if="order.allEarnings" class="value">{{ order.allEarnings }}</span>
                                            <span v-else class="value">&mdash;</span>
                                        </div>
                                        <div>
                                            <span class="sub-option">Ваш:</span>
                                            <span v-if="order.myEarnings" class="value">{{ order.myEarnings }}</span>
                                            <span v-else class="value">&mdash;</span>
                                        </div>
                                        <div v-if="order.isPartnerOrder">
                                            <span class="sub-option">Агента:</span>
                                            <span v-if="order.partnerEarnings" class="value">{{
                                                    order.partnerEarnings
                                                }}</span>
                                            <span v-else class="value">&mdash;</span>
                                        </div>
                                    </div>
                                </div>
                                <div style="margin-top: auto;color: #999DA6;" class="info-block">
                                    <div class="info-link">
                                        <div class="mb-2 mt-1" style="color: #24282C; font-size: 14px">{{ order.insuranceObject.number }}</div>
                                    </div>
                                    <div class="info-link" v-if="showOption(order,'prolongation_contract') && !isFisReferal()">
                                        <svg style="margin-bottom: 4px" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M11.6 3.2002H4.4C3.07452 3.2002 2 4.27471 2 5.6002V11.6002C2 12.9257 3.07452 14.0002 4.4 14.0002H11.6C12.9255 14.0002 14 12.9257 14 11.6002V5.6002C14 4.27471 12.9255 3.2002 11.6 3.2002Z" stroke="#999DA6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path d="M5.59961 2V4.4" stroke="#999DA6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path d="M10.4004 2V4.4" stroke="#999DA6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                            <path d="M2 6.80029H14" stroke="#999DA6" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                        </svg>
                                        <div class="d-inline-flex" style="margin-bottom: 15px">
                                            <prolongation-choice
                                                @prolong-new="prolongNew(order)"
                                                @prolong-current="prolong(order)"
                                                :isLoadingNew="loadProcessNew"
                                                :isLoadingCurrent="loadProcessCurrent"
                                            >
                                            </prolongation-choice>
                                        </div>
                                    </div>
                                    <div class="info-link" v-if="isConcluded(order)">
                                      <svg width="16" height="16"
                                           viewBox="0 0 16 16" fill="none"
                                           xmlns="http://www.w3.org/2000/svg">
                                        <g clip-path="url(#clip0)">
                                        <path
                                            d="M0.666504 8C0.666504 8 3.33317 2.66667 7.99984 2.66667C12.6665 2.66667 15.3332 8 15.3332 8C15.3332 8 12.6665 13.3333 7.99984 13.3333C3.33317 13.3333 0.666504 8 0.666504 8Z"
                                            stroke="#999DA6" stroke-width="2" stroke-linecap="round"
                                            stroke-linejoin="round"/>
                                        <path
                                            d="M8 10C9.10457 10 10 9.10457 10 8C10 6.89543 9.10457 6 8 6C6.89543 6 6 6.89543 6 8C6 9.10457 6.89543 10 8 10Z"
                                            stroke="#999DA6" stroke-width="2" stroke-linecap="round"
                                            stroke-linejoin="round"/>
                                            </g>
                                            <defs>
                                            <clipPath id="clip0">
                                            <rect width="16" height="16" fill="white"/>
                                            </clipPath>
                                            </defs>
                                        </svg>
                                        <span @click="goToOrderInfo(order)">Переглянути</span>
                                    </div>
                                    <div class="info-link" v-else-if="isOverdue(order) && !hideCopyForApiMethod(order)">
                                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none"
                                            xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M13.3333 6H7.33333C6.59695 6 6 6.59695 6 7.33333V13.3333C6 14.0697 6.59695 14.6667 7.33333 14.6667H13.3333C14.0697 14.6667 14.6667 14.0697 14.6667 13.3333V7.33333C14.6667 6.59695 14.0697 6 13.3333 6Z"
                                            stroke="#999DA6" stroke-width="2" stroke-linecap="round"
                                            stroke-linejoin="round"/>
                                        <path
                                            d="M3.3335 10H2.66683C2.31321 10 1.97407 9.85952 1.72402 9.60947C1.47397 9.35942 1.3335 9.02028 1.3335 8.66666V2.66666C1.3335 2.31304 1.47397 1.9739 1.72402 1.72385C1.97407 1.4738 2.31321 1.33333 2.66683 1.33333H8.66683C9.02045 1.33333 9.35959 1.4738 9.60964 1.72385C9.85969 1.9739 10.0002 2.31304 10.0002 2.66666V3.33333"
                                            stroke="#999DA6" stroke-width="2" stroke-linecap="round"
                                            stroke-linejoin="round"/>
                                        </svg>
                                        <span @click="copy(order)">Копіювати</span>
                                    </div>
                                    <div class="info-link" v-else-if="isDraft(order)">
                                        <svg width="16" height="16" viewBox="0 0 16 16"
                                             fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M12.0415 7.74999C12.0398 8.88764 11.5871 9.9782 10.7827 10.7826C9.97822 11.5871 8.88766 12.0398 7.75001 12.0415C6.61223 12.0399 5.52149 11.5873 4.71686 10.7828C3.91223 9.97841 3.45936 8.88777 3.45751 7.74999C3.45896 6.61199 3.91167 5.52103 4.71636 4.71634C5.52104 3.91166 6.61201 3.45894 7.75001 3.45749C8.70651 3.45749 9.58251 3.77249 10.295 4.30049L9.40401 5.19249L13.619 6.32049L12.489 2.10699L11.544 3.05199C10.4712 2.18163 9.13151 1.70689 7.75001 1.70749C4.41301 1.70899 1.70901 4.41249 1.70801 7.74999C1.70901 11.0875 4.41301 13.7915 7.75001 13.7915C11.087 13.7915 13.7915 11.0875 13.7915 7.74999H12.0415Z"
                                                fill="#999DA6"/>
                                        </svg>
                                        <span @click="declare(order)">Продовжити</span>
                                    </div>
                                    <div class="info-link" v-else-if="isDeclared(order)">
                                        <svg width="16" height="16" viewBox="0 0 16 16"
                                             fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path
                                                d="M12.0415 7.74999C12.0398 8.88764 11.5871 9.9782 10.7827 10.7826C9.97822 11.5871 8.88766 12.0398 7.75001 12.0415C6.61223 12.0399 5.52149 11.5873 4.71686 10.7828C3.91223 9.97841 3.45936 8.88777 3.45751 7.74999C3.45896 6.61199 3.91167 5.52103 4.71636 4.71634C5.52104 3.91166 6.61201 3.45894 7.75001 3.45749C8.70651 3.45749 9.58251 3.77249 10.295 4.30049L9.40401 5.19249L13.619 6.32049L12.489 2.10699L11.544 3.05199C10.4712 2.18163 9.13151 1.70689 7.75001 1.70749C4.41301 1.70899 1.70901 4.41249 1.70801 7.74999C1.70901 11.0875 4.41301 13.7915 7.75001 13.7915C11.087 13.7915 13.7915 11.0875 13.7915 7.74999H12.0415Z"
                                                fill="#999DA6"/>
                                        </svg>
                                        <span @click="declare(order,false,false,2)">Продовжити</span>
                                    </div>
                                    <div>
                                        <div v-if="loadMoreOptions[order.id + order.typeId] === true"
                                             class="option-loader spinner-border"
                                             style="height: 20px; width: 20px; margin-top: 11px;"
                                             role="status">
                                        </div>
                                        <more-options style="padding-top: 5px"
                                                      v-else :status-order="showStatusId(order)"
                                                      @download-draft="downloadDraft(order)"
                                                      @download-contract="downloadContract(order)"
                                                      @show-order="goToOrderInfo(order)"
                                                      @proceed-order="declare(order)"
                                                      @confirm-order="declare(order,false,false,2)"
                                                      @open-mtsbu-link="openMtsbuLink(order)"
                                                      @get-payment-invoice="getPaymentInvoice(order)"
                                                      :is-exist-mtsbu-link="showMtsbuLink(order)"
                                                      @copy-order="copy(order)"
                                        >
                                        </more-options>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <modal-get-invoice-order ref="modalGetInvoiceOrder"></modal-get-invoice-order>
        <modal-get-driver-birthday ref="modalGetDriverBirthday" @close-driver-birthday="closeDriverBirthday" @confirm-driver-birthday="modalConfirmDriverBirthday"></modal-get-driver-birthday>
        <prolongation-modal ref="prolongationModal"
            @prolong-new="prolongNew"
            @hide-prolongation-modal="hideProlongationModal"
        ></prolongation-modal>
    </div>
</template>


<script>
import Vue from 'vue';
import { ClientInfo, MoreOptions, ProlongationChoice, ProlongationModal, RowBlockSkeleton, RowMobileBlockSkeleton } from './components';
import { changeProlongStatus } from '@/api/order';
import modalGetDriverBirthday from '@/components/app/modals/modal-get-driver-dirthday';
import { GetInvoiceOrder as ModalGetInvoiceOrder } from '@/components/app/modals/order';
import { customerMixin, HistoryMixin, orderMixin } from '@/mixin';

const FileDownload = require('js-file-download');

// Поліс пересоздано вручну — кнопку пролонгації не показуємо
const PROLONG_CLIENT_STATUS_ISSUED = 8;

export default {
  mixins: [orderMixin, customerMixin, HistoryMixin],
  components: { MoreOptions, RowBlockSkeleton, RowMobileBlockSkeleton, ClientInfo, ModalGetInvoiceOrder, ProlongationChoice, ProlongationModal, modalGetDriverBirthday },
  props: {
    countProlongation: {
      type: Number,
      default: () => {
        return 0;
      }
    },
    isLoadData: {
      type: Boolean,
      default: () => {
        return true;
      }
    },
    isMobile: {
      type: Boolean,
      default: () => {
        return true;
      }
    },
    prolongation: {
      type: Array,
      default: () => {
        return [{
          dgo: {},
          statusId: null,
          fullName: null,
          earning: null,
          contract: {},
          companyInfo: {},
          insurant: {},
          insured: {},
          price: null,
          dgoPrice: null,
          autolawyerPrice: null,
          discountPrice: null,
        }];
      },
    },
    orders: {
      type: Array,
      default: () => {
        return [{
          dgo: {},
          statusId: null,
          fullName: null,
          earning: null,
          contract: {},
          companyInfo: {},
          insurant: {},
          insured: {},
          price: null,
          dgoPrice: null,
          autolawyerPrice: null,
          discountPrice: null,
        }];
      },
    },
    prolongStatuses:{
      type: Array,
      default: () => []
    },
  },

  data: function () {
    return {
      loadContract: {},
      loadConclude: {},
      loadMoreOptions: {},
      loadProlongationModal: false,
      loadProcessNew: false,
      loadProcessCurrent: false,
      isCopyProcess: false,
      listQuery: {
        statusLost: null,
        prolongClientStatus: 0,
      },
      searchData: {
        carType: { 'name':'Легкові автомобілі','group':'CAR', 'external_id':'A',
          'engines':[{ 'name':'до 1600 см3','value':'A1' },
            { 'name':'1601-2000 см3','value':'A2' },
            { 'name':'2001-3000 см3','value':'A3' },
            { 'name':'более 3001 см3','value':'A4' }], 'types':[] },
      },
      experience: { 'name':'Менше 3 років','value':false },
      periodOptions: [
        { 'id': 15, 'count':'15', 'key':'d', 'name' : '15 д' },
        { 'id': 1, 'count':'1', 'key':'m', 'name' : '1 міс' },
        { 'id': 2, 'count':'2', 'key':'m', 'name' : '2 міс' },
        { 'id': 3, 'count':'3', 'key':'m', 'name' : '3 міс' },
        { 'id': 4, 'count':'4', 'key':'m', 'name' : '4 міс' },
        { 'id': 5, 'count':'5', 'key':'m', 'name' : '5 міс' },
        { 'id': 6, 'count':'6', 'key':'m', 'name' : '6 міс' },
        { 'id': 7, 'count':'7', 'key':'m', 'name' : '7 міс' },
        { 'id': 8, 'count':'8', 'key':'m', 'name' : '8 міс' },
        { 'id': 9, 'count':'9', 'key':'m', 'name' : '9 міс' },
        { 'id': 10, 'count':'10', 'key':'m', 'name' : '10 міс' },
        { 'id': 11, 'count':'11', 'key':'m', 'name' : '11 міс' },
        { 'id': 12, 'count':'12', 'key':'m', 'name' : '12 міс' },
      ],
      carTypes: [
        {
          'name':'Легкові автомобілі',
          'group':'CAR',
          'external_id':'B1',
          'types':[
            { 'name':'до 1600 см3','value':'B1' },
            { 'name':'1601-2000 см3','value':'B2' },
            { 'name':'2001-3000 см3','value':'B3' },
            { 'name':'более 3001 см3','value':'B4' }
          ],
          'engines':[]
        },
        {
          'name':'Автобус',
          'group':'BUS',
          'engines':[],
          'types':[
            { 'name':'менше 20 осіб','value':'D1' },
            { 'name':'більше 20 осіб','value':'D2' }
          ]
        },
        {
          'name':'Вантажні автомобілі',
          'group':'CARGO',
          'engines':[],
          'types':[
            { 'name':'С0 (з повною масою до 2,4т та вантажопідйомністю до 2т)','value':'C0' },
            { 'name':'С1 (з повною масою більше 2,4т та вантажопідйомністю до 2т (включно))','value':'C1' },
            { 'name':'С2 (з вантажопідйомністю більше 2т)','value':'C2' }
          ]
        },
        {
          'name':'Причіп, Трейлер',
          'group':'TRAILER',
          'engine':null,
          'engines':[],
          'types':[
            { 'name':'До вантажного авто','value':'E' },
            { 'name':'До легкового авто','value':'F' }
          ]
        },
        {
          'name':'Мотоцикли та моторолери',
          'group':'BIKE',
          'external_id':'A1',
          'types':[
            { 'name':'300 см3 або менше','value':'A1' },
            { 'name':'більше 300 см3','value':'A2' }
          ],
          'engines':[]
        },
        {
          'name':'Легковий електромобіль',
          'group':'CAR',
          'external_id':'B5',
          'engine':null,
          'engines':[],
          'types':[]
        }
      ],
      carTypesGreenCard: [
        { 'name':'Легкові автомобілі','group':'CAR', 'external_id':'A',
          'engines':[
            { 'name':'до 1600 см3','value':'A1' },
            { 'name':'1601-2000 см3','value':'A2' },
            { 'name':'2001-3000 см3','value':'A3' },
            { 'name':'более 3001 см3','value':'A4' }],
          'types':[] },
        { 'name':'Автобус','group':'BUS', 'external_id':'E', 'engines':[],
          'types':[
            { 'name':'менше 20 осіб','value':'E1' },
            { 'name':'більше 20 осіб','value':'E2' }] },
        {
          'name':'Вантажні автомобілі',
          'group':'CARGO',
          'external_id':'C',
          'engines':[],
          'types':[
            { 'name':'С0 (з повною масою до 2,4т та вантажопідйомністю до 2т)','value':'C0' },
            { 'name':'С1 (з повною масою більше 2,4т та вантажопідйомністю до 2т (включно))','value':'C1' },
            { 'name':'С2 (з вантажопідйомністю більше 2т)','value':'C2' }
          ]
        },
        { 'name':'Причіп, Трейлер','group':'TRAILER','engine':null, 'external_id':'F', 'engines':[],
          'types':[{ 'name':'До вантажного авто','value':'F' },
            { 'name':'До легкового авто','value':'F' }] },
        { 'name':'Мотоцикли та моторолери','group':'BIKE', 'external_id':'B',
          'engines':[{ 'name':'300 см3 або менше','value':'B1' },
            { 'name':'більше 300 см3','value':'B2' }], 'types':[] }
      ],
      countriesOptions: [
        { 'id': 60,'name': 'Європа','name_ru': 'Европа' },
        { 'id': 117,'name': 'Молдова','name_ru': 'Молдова' }
      ],
      prolongTypesList: [
        { id: 1, name: 'Нагадано клієнту' },
        { id: 2, name: 'Продав авто' },
        { id: 3, name: 'Оформив в інших' },
        { id: 4, name: 'Немає зв’язку' },
        { id: 5, name: 'Очікує рішення' },
        { id: 6, name: 'Зацікавлений' },
      ],
    };
  },
  computed: {
    orderTypes: function () {
      return this.$store.getters.ORDER_TYPES;
    },
  },
  methods: {
    isFisReferal(){
      return parseInt(this.$store.getters.USER?.recipientTypeId) == 4;
    },
    modalConfirmDriverBirthday(birthdayAt){
      this.confirmDriverBirthday(birthdayAt);
    },
    closeDriverBirthday(order){
      this.loadProcessNew = false;
      this.loadProcessCurrent = false;
      Vue.set(this.loadMoreOptions, order.id + parseInt(order.typeId), false);
    },
    changeProlongStatus(status, order) {
      const params = {
        orderId: order.id,
        statusId: status,
      };

      changeProlongStatus(params).then((response) => {
        //console.log(response?.data)
      }).catch((error) => {
        console.log(error);
      });
    },
    filterStatusWrap: function() {
      return this.$emit('filter-status-wrap');
    },
    getPaymentInvoice: async function(order) {
      this.$refs.modalGetInvoiceOrder.open(order.id);
    },
    getProlongStatuses() {
      return this.prolongStatuses.filter(i => i.id !== 0 && i.id !== 7);
    },
    getProlongClientStatuses() {
      return this.prolongStatuses.filter(i => i.id !== 7);
    },
    getProlongLostStatus() {
      return this.prolongStatuses.find(i => i.statusLost);
    },
    getSelectClass(value) {
      return `active-${value}`;
    },
    hideProlongationModal() {
      this.loadProlongationModal = !this.loadProlongationModal;
    },
    prolong: async function(order) {
      this.loadProcessCurrent = true;
      await this.copy(order, true);
    },
    prolongNew: async function(order) {
      this.loadProcessNew = true;
      await this.copy(order, true, true);
    },
    isDraftTab: function () {
      return this.listQuery.statusId === this.draftStatus;
    },
    isCanceledTab: function () {
      return this.listQuery.statusId === this.canceledStatus;
    },
    isDeclaredTab: function () {
      return this.listQuery.statusId === this.declaredStatus;
    },
    isProlongation: function () {
      return this.listQuery.statusId === this.prolongationStatus.id;
    },
    showMonths: function(order) {
      if(order.typeId !== this.orderTypes['dgo'] && order.usageMonths != null && order.usageMonths != undefined && order.usageMonths != '')
        return true;
      return false;
    },
    showOption: function (order,name){
      if (['prolongation_contract',].includes(name)) {
        if (order.typeId == 7) {
          return false;
        }
        if (Number(order.prolongClientStatus) === PROLONG_CLIENT_STATUS_ISSUED) {
          return false;
        }
      }
      return true;
    },
    activateTab :function (status, numeric = true) {
      const prolongClientStatus = (typeof status === 'object' && status !== null) ? status.id : status;
      const statusLost = (typeof status === 'object' && status !== null) ? status.statusLost : (status === 7) ? 1 : null;

      if (statusLost) {
        const oneWeekAgo = new Date();
        let fiveDaysAgo = new Date(new Date().setDate(new Date().getDate() - 7));

        fiveDaysAgo.setHours(0, 0, 0, 0);
        this.dateFilter = [fiveDaysAgo, moment().startOf('day')];

        const finishedFrom = moment(this.dateFilter[0]).format();
        const finishedTo =  moment(this.dateFilter[1]).format();
        const page = 1;

        this.$emit('change-filter-params', this.dateFilter, page);

        this.$set(this.listQuery, 'finishedTo', finishedTo);
        this.$set(this.listQuery, 'finishedFrom', finishedFrom);
        this.$set(this.listQuery, 'statusLost', 1);
        this.$set(this.listQuery, 'prolongClientStatus', null);
      } else {

        if (this.listQuery.statusLost) {
          const oneWeekAgo = new Date();
          oneWeekAgo.setDate(oneWeekAgo.getDate());
          oneWeekAgo.setHours(0, 0, 0, 0);
          this.dateFilter = [oneWeekAgo, moment().add(30, 'days')];
          const finishedFrom = moment(this.dateFilter[0]).format();
          const finishedTo =  moment(this.dateFilter[1]).format();

          this.$emit('change-filter-dates', this.dateFilter);

          this.$set(this.listQuery, 'finishedTo', finishedTo);
          this.$set(this.listQuery, 'finishedFrom', finishedFrom);
          this.$set(this.listQuery, 'statusLost', null);
        }
        this.$set(this.listQuery, 'prolongClientStatus', prolongClientStatus);
      }
    },
  },
  watch: {
    'listQuery.prolongClientStatus': function (newValue, oldValue) {
      this.$emit('init-orders-list', 1);
    }
  }
};
</script>
